module.exports = __webpack_public_path__ + "img/wtx.55c250d1.png";